import React from 'react';
import clsx from 'clsx';

import Container from '@common/Container';
import Section from '@common/Section';
import Img from '@common/Image';
import RichText from '@common/RichText';

import * as styles from '@common/blocks/flex/bordered-list/bordered-list.module.scss';

const BorderedList = ({ data }) => {
    const {
      text,
      images,
      listClass,
      topMargin,
      bottomMargin,
      bgColour
    } = data;
    return (
      <Section spacing={clsx(topMargin, bottomMargin ? bottomMargin : 'mb-7')} className={clsx({[`bg-${bgColour} py-5`]: bgColour})}>
        <Container>
          <div className='position-relative'>
            {images &&
              <div className={styles.topImg}>
                {images.map(image => (
                  <Img
                    key={image.id}
                    loading='eager'
                    image={image.gatsbyImageData}
                    file={image.file}
                    alt={image.description}
                  />
                ))}
              </div>
            }
          </div>
          <div className='border border-3 border-dark-grey-4 rounded pt-5 pb-4 px-4'>
            {text &&
              <RichText
                json={text}
                h1='mb-3'
                h2='mb-3'
                p='fs-32 fw-medium mb-0'
                a='fs-16'
                ul={clsx('row row-cols-lg-2 gy-3', listClass)}
              />
            }
          </div>
        </Container>
      </Section>
    )
}

export default BorderedList
